<template>
  <div v-if="leftBar.searchResult">
    <v-list class="leftBarTabsItem">
      <div class="leftBar-img">
        <div class="leftBar-img-location"></div>
        <div class="leftBar-img-button"></div>
      </div>
      <v-list
        v-if="
          !Array.isArray(leftBar.searchResult) ||
          leftBar.searchResult.length == 0
        "
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title
              ><v-icon large>sentiment_very_dissatisfied</v-icon
              >{{ $t("common.recordnotfound") }}</v-list-item-title
            ></v-list-item-content
          ></v-list-item
        >
      </v-list>
      <v-card
        tile
        :key="index"
        v-else
        v-for="(resultItem, index) in leftBar.searchResult"
        @click.stop="
          leftBar.updateSelectMarkerWithScrollList({
            leaflet_id: resultItem.leaflet_id,
            isShowLeftBar: false,
            zoomIn: true,
          });
          $GA.sr_click_result_item_zoom();
        "
      >
        <v-list-item
          :ref="
            resultItem.layer != null && resultItem.leaflet_id
              ? resultItem.leaflet_id
              : null
          "
          class="leftBarTabsItemItem"
          :title="$t('common.title_zoomTo')"
        >
          <v-img
            v-if="core.leftBarWidthSize != 'xs'"
            class="leftBarTabsItemItemIcon"
            :src="
              resultItem.leaflet_id == null ||
              resultItem.leaflet_id !==
                core.currentSelectedSearchResultLeafletId
                ? 'lib/images/marker-icon-green-search.png'
                : 'lib/images/marker-icon-red-search.png'
            "
          ></v-img>
          <v-list-item-content>
            <v-list-item-title>
              <v-img
                v-if="core.leftBarWidthSize == 'xs'"
                class="leftBarTabsItemItemIcon"
                :src="
                  resultItem.leaflet_id == null ||
                  resultItem.leaflet_id !==
                    core.currentSelectedSearchResultLeafletId
                    ? 'lib/images/marker-icon-green-search.png'
                    : 'lib/images/marker-icon-red-search.png'
                "
              ></v-img>
            </v-list-item-title>

            <v-list-item-title
              v-if="resultItem.ename"
              style="white-space: normal"
              >{{ resultItem.ename }}</v-list-item-title
            >
            <v-list-item-title
              v-if="resultItem.cname"
              style="white-space: normal"
              >{{ resultItem.cname }}</v-list-item-title
            >

            <v-list-item-subtitle
              v-if="resultItem.eaddress && resultItem.caddress"
              style="white-space: normal"
              >&nbsp;&nbsp;&nbsp;</v-list-item-subtitle
            >
            <v-list-item-subtitle
              v-if="resultItem.eaddress && resultItem.caddress"
              style="white-space: normal"
              >&nbsp;&nbsp;&nbsp;</v-list-item-subtitle
            >

            <v-list-item-subtitle
              v-if="resultItem.eaddress"
              style="white-space: normal"
              >{{ resultItem.eaddress }}</v-list-item-subtitle
            >
            <v-list-item-subtitle
              v-if="resultItem.caddress"
              style="white-space: normal"
              >{{ resultItem.caddress }}</v-list-item-subtitle
            >
          </v-list-item-content>

          <LeftBarSubButtons
            v-if="core.leftBarWidthSize != 'xs'"
            :core="core"
            :tour="tour"
            :data="{
              latLng: resultItem.leaflet_id
                ? core.getXYByLeafletId(resultItem.leaflet_id)
                : null,
              name_zh: resultItem.cname,
              name_en: resultItem.ename,
              address_zh: resultItem.caddress,
              address_en: resultItem.eaddress,
              resultType: 'searchResult',
            }"
            :showAdvanced="true"
            :index="index"
          ></LeftBarSubButtons>
        </v-list-item>

        <LeftBarSubButtons
          v-if="core.leftBarWidthSize == 'xs'"
          :core="core"
          :tour="tour"
          :data="{
            latLng: resultItem.leaflet_id
              ? core.getXYByLeafletId(resultItem.leaflet_id)
              : null,
            name_zh: resultItem.cname,
            name_en: resultItem.ename,
            address_zh: resultItem.caddress,
            address_en: resultItem.eaddress,
            resultType: 'searchResult',
          }"
          :index="index"
          :showAdvanced="true"
        ></LeftBarSubButtons>
      </v-card>
    </v-list>
  </div>
</template>

  <!-- leaflet -->
  <script src="./lib/leaflet.js"></script>
  <link rel="stylesheet" href="./lib/leaflet.css" />

<script>
import LeftBarSubButtons from "./LeftBarSubButtons";

export default {
  components: { LeftBarSubButtons },

  data() {
    return {};
  },

  props: ["core", "tour", "leftBar"],

  methods: {
    init() {
      let me = this;
      me.leftBar.enableLeftBarTabsClearIdentifyResults(false);
      this.leftBar.chgToolBarButtons({
        toolbarTitle: "",
        toolbarExtent: () => {
          me.core.$GA.sr_click_extent();
          me.leftBar.extentSearchResultDrawnItemBounds();
        },
        toolbarTrash: () => {
          me.core.$GA.sr_click_trash();
          me.leftBar.searchResult = null;

          me.core.searchBar.searchKeywordModel = null;
          me.leftBar.toolbarTitle = "";

          me.leftBar.openDynamicTab({ dynamicTab: null, showLeftBar: false });

          me.leftBar.enableLeftBarTabsClearIdentifyResults(true);
        },
      });
    },
  },
};
</script>